import { all } from 'redux-saga/effects';
import syncCheck from './slices/syncCheck/sagas';
import user from './slices/user/sagas';

export default function* rootSaga() {
  // @ts-expect-error TS7057 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  return yield all([syncCheck, user]);
}
